export const c = {

  /* ── Navigation ─────────────────────────────────────────────── */
  nav: {
    links: [
      { href: "#portfolio", pl: "Portfolio", en: "Portfolio" },
      { href: "#uslugi",    pl: "Usługi",    en: "Services"  },
      { href: "#proces",    pl: "Proces",    en: "Process"   },
      { href: "#o-nas",     pl: "O nas",     en: "About"     },
      { href: "#opinie",    pl: "Opinie",    en: "Reviews"   },
      { href: "#wycena",    pl: "Wycena",    en: "Pricing"   },
      { href: "#faq",       pl: "FAQ",       en: "FAQ"       },
      { href: "#kontakt",   pl: "Kontakt",   en: "Contact"   },
    ],
    cta: { pl: "Napisz do nas →", en: "Write to us →" },
  },

  /* ── Hero ────────────────────────────────────────────────────── */
  hero: {
    overline: { pl: "Poznań · Praca zdalna", en: "Poznań · Remote" },
    line1:    { pl: "Tworzymy rozwiązania cyfrowe, które", en: "We build digital solutions that" },
    ice:      { pl: "pomagają firmom rosnąć.",            en: "help businesses grow."         },
    keywords: {
      pl: "Strony www · aplikacje webowe · SaaS · Poznań & remote",
      en: "Websites · web apps · SaaS · Poznań & remote",
    },
    subtitle: {
      pl: "Od pierwszej rozmowy aż po wdrożenie masz kontakt z ludźmi, którzy naprawdę poznają Twój biznes i wspólnie z Tobą tworzą rozwiązanie dopasowane do jego potrzeb.",
      en: "From the first conversation to launch, you work with people who truly understand your business and co-create a solution tailored to its needs.",
    },
    cta1:   { pl: "Wyślij zapytanie", en: "Send an inquiry" },
    cta2:   { pl: "Zobacz nasze realizacje",   en: "See our work"             },
    scroll: { pl: "Przewiń",                     en: "Scroll"                   },
  },

  /* ── Marquee metrics ─────────────────────────────────────────── */
  marquee: {
    metrics: {
      pl: ["STRONY · SKLEPY · APLIKACJE", "PROJEKTY NA ŻYWO", "SZYBKOŚĆ MIERZYMY, NIE OBIECUJEMY", "MOBILE-FIRST", "CORE WEB VITALS POD KONTROLĄ", "PARTNERZY CYFROWI", "PWA READY", "SEO OD PODSTAW", "ZERO TEMPLATÓW", "POZNAŃ · PL"],
      en: ["WEBSITES · STORES · APPS", "PROJECTS LIVE", "WE MEASURE SPEED, NOT PROMISE IT", "MOBILE-FIRST", "CORE WEB VITALS UNDER CONTROL", "DIGITAL PARTNERS",    "PWA READY", "SEO BUILT-IN", "ZERO TEMPLATES",  "POZNAŃ · PL"],
    },
  },

  /* ── Portfolio ───────────────────────────────────────────────── */
  portfolio: {
    label:    { pl: "Realizacje",             en: "Projects"               },
    heading1: { pl: "Portfolio, które",       en: "Work that"              },
    ice:      { pl: "mówi samo za siebie.",   en: "speaks for itself."     },
    subtitle: {
      pl: "Dziewięć projektów — od sklepów internetowych i interaktywnego katalogu, przez strony firmowe, portal nieruchomości i terminal kontenerowy, po SaaS w przygotowaniu. Przewiń, żeby zobaczyć całość.",
      en: "Nine projects — from online stores and an interactive catalogue, through company websites, a real estate portal and a container terminal, to SaaS in the works. Scroll to see them all.",
    },
    // Teksty kart kluczowane id karty z Portfolio.jsx (kolejność wyświetlania ustala Portfolio.jsx).
    cards: {
      "quick-home": {
        tag:  { pl: "Producent domów modułowych · Strona firmowa", en: "Modular Home Manufacturer · Company Website" },
        desc: {
          pl: "Dwa produkty, jedna strona — z konfiguratorem, który na bieżąco przelicza wycenę wybranego domu modułowego, od metrażu po docieplenie.",
          en: "Two products, one page — featuring a configurator that recalculates the price of the chosen modular home live, from floor area to insulation.",
        },
      },
      "gusti-katalog-prezentow": {
        tag:  { pl: "Katalog interaktywny · Zestawy prezentowe",     en: "Interactive Catalogue · Gift Sets"   },
        desc: {
          pl: "Katalog Collezione Regali 2026 do kartkowania jak książka: 46 stron, 19 zestawów prezentowych i przycisk „Zapytaj o ofertę” przy każdym z nich. Działa na komputerze i na telefonie.",
          en: "The Collezione Regali 2026 catalogue you page through like a book: 46 pages, 19 gift sets and an “Ask for an offer” button on each. Works on desktop and on a phone.",
        },
      },
      "kolorowy-motylek": {
        tag:  { pl: "Sklep internetowy · Papeteria i zabawki",       en: "E-commerce · Stationery & Toys"      },
        desc: {
          pl: "Sklep szkolno-papierniczy z autorskim motywem WooCommerce: kolorowe kategorie, gotowe zestawy do szkoły dodawane do koszyka jednym kliknięciem i usługa „Wyprawka szkolna” — klient wysyła listę, sklep kompletuje zamówienie.",
          en: "A school-supplies and toy store with a custom WooCommerce theme: colourful categories, ready-made school kits added to the cart in one click and a “School kit” service — the customer sends the list, the store assembles the order.",
        },
      },
      "aptacy-nieruchomosci": {
        tag:  { pl: "Portal nieruchomości · Full-stack",        en: "Real Estate Portal · Full-stack"   },
        desc: {
          pl: "Zamiast chaosu typowego dla portali nieruchomości, celem było stworzenie spokojnego i premium doświadczenia przeglądania ofert.",
          en: "Instead of the chaos typical of real estate portals, the goal was to create a calm, premium experience for browsing listings.",
        },
      },
      "quickhub-terminal": {
        tag:  { pl: "Terminal kontenerowy · Strona firmowa",    en: "Container Terminal · Company Website" },
        desc: {
          pl: "Klient biznesowy nie czyta opisów — szuka kontenera, ceny i telefonu. Strona działa jak przedłużenie działu handlowego, nie broszura.",
          en: "A B2B buyer doesn't read copy — they look for a container, a price and a phone number. The site works like an extension of the sales team, not a brochure.",
        },
      },
      "szkolenia-balans": {
        tag:  { pl: "Strona firmowa · Motion Design",           en: "Company Website · Motion Design"   },
        desc: {
          pl: "Platforma została zaprojektowana tak, aby budować poczucie oddechu, spokoju i przestrzeni — zamiast przypominać kolejny przeładowany system kursów.",
          en: "The platform was designed to convey a sense of space, calm and openness — rather than looking like another overloaded course system.",
        },
      },
      "bottomline": {
        tag:  { pl: "Biuro rachunkowe · Strona firmowa",       en: "Accounting Firm · Company Website" },
        desc: {
          pl: "Biuro rachunkowe potrzebowało strony, która buduje zaufanie od pierwszego wejrzenia — bez korporacyjnego chłodu i sztywnych formularzy kontaktowych. Stonowana, ciemna szata graficzna i bezpośredni kontakt z księgową zamiast anonimowej infolinii.",
          en: "An accounting firm needed a site that builds trust at first glance — without corporate coldness or stiff contact forms. A calm, dark visual identity and direct contact with the accountant instead of an anonymous hotline.",
        },
      },
      "gusti-di-italia": {
        tag:  { pl: "Sklep internetowy · Delikatesy włoskie",        en: "E-commerce · Italian Delicatessen"   },
        desc: {
          pl: "Sklep bezpośredniego importera włoskich delikatesów na Shoperze: autorski motyw w czerni i złocie, kategorie ułożone jak karta w restauracji i wejście do osobnego katalogu prezentów.",
          en: "The store of a direct importer of Italian delicacies on Shoper: a custom black-and-gold theme, categories laid out like a restaurant menu and an entry to a separate gift catalogue.",
        },
      },
      "przestrzen-control": {
        tag:  { pl: "SaaS · Panel zarządzania · Event-tech",    en: "SaaS · Management Panel · Event-tech" },
        desc: {
          pl: "SaaS musi budzić zaufanie od pierwszych sekund. Architektura informacji, motion i hierarchy zostały zaprojektowane tak, aby prowadzić uwagę użytkownika bez przeciążenia.",
          en: "SaaS must build trust from the first second. Information architecture, motion and hierarchy were designed to guide user attention without overload.",
        },
      },
      // wstrzymany (hidden w Portfolio.jsx) — zostawiony do przywrócenia
      "majowkowy-balans": {
        tag:  { pl: "Event App · Android · Offline-first",      en: "Event App · Android · Offline-first" },
        desc: {
          pl: "Cztery dni, jeden event, zero improwizacji. Aplikacja stworzona wyłącznie na Majówkowy wyjazd z Balansem — harmonogram aktywności, mapa tras i powiadomienia grupowe działające bez zasięgu.",
          en: "Four days, one event, zero improvisation. An app built exclusively for the Majówkowy Balans retreat — activity schedule, trail map and group notifications working offline.",
        },
      },
    },
    cta_title: { pl: "Twój projekt",                                      en: "Your project"                              },
    cta_desc:  { pl: "Każde zlecenie traktujemy jak własny produkt.",       en: "We treat every project as our own product."  },
    cta_btn:   { pl: "Porozmawiajmy o Twoim pomyśle →",                    en: "Let's talk about your idea →"              },
  },

  /* ── Services ────────────────────────────────────────────────── */
  services: {
    label:    { pl: "Co robimy",         en: "What we do"    },
    heading1: { pl: "Cztery obszary.",  en: "Four domains." },
    ice:      { pl: "Jedna filozofia.",  en: "One philosophy." },
    subtitle: {
      pl: "Pomagamy firmom rozwijać się dzięki dobrze zaprojektowanym rozwiązaniom cyfrowym. Każdy projekt zaczyna się od zrozumienia biznesu — nie od szablonu.",
      en: "We help businesses grow through well-designed digital solutions. Every project starts with understanding the business — not from a template.",
    },
    cards: [
      {
        title:    { pl: "Strony internetowe",  en: "Websites"           },
        desc:     {
          pl: "Landing pages, strony firmowe, portale i blogi. Pełen motion design, SEO, szybkość i mobile-first. Każdy piksel zaprojektowany pod Twój brand.",
          en: "Landing pages, company websites, portals and blogs. Full motion design, SEO, speed and mobile-first. Every pixel designed for your brand.",
        },
        features: {
          pl: ["Motion design & animacje", "SEO & szybkość", "Mobile-first responsive", "CMS lub statyczny build"],
          en: ["Motion design & animations", "SEO & speed", "Mobile-first responsive", "CMS or static build"],
        },
      },
      {
        title:    { pl: "Aplikacje webowe",    en: "Web Applications"   },
        desc:     {
          pl: "PWA, panele administracyjne, systemy CRM/CMS. Z autoryzacją, rolami i backendem pod klucz.",
          en: "PWA, admin panels, CRM/CMS systems. With authentication, roles and a full backend.",
        },
        features: {
          pl: ["Autoryzacja & role", "Panel admina", "REST & GraphQL"],
          en: ["Authentication & roles", "Admin panel", "REST & GraphQL"],
        },
      },
      {
        title:    { pl: "SaaS & Produkty",     en: "SaaS & Products"    },
        desc:     {
          pl: "Od MVP, przez płatności subskrypcyjne, po pełen launch. Stripe, Supabase, analytics i system ról.",
          en: "From MVP, through subscription payments, to a full launch. Stripe, Supabase, analytics and a role system.",
        },
        features: {
          pl: ["Stripe & subskrypcje", "Supabase / baza danych", "Analytics & metryki"],
          en: ["Stripe & subscriptions", "Supabase / database", "Analytics & metrics"],
        },
      },
      {
        title:    { pl: "Sklepy & E-commerce", en: "Stores & E-commerce" },
        desc:     {
          pl: "Sklepy ze Stripe, zarządzaniem zamówieniami, panelem admina i checkoutem premium. Bez Shopify — własny kod, własne reguły, własna marka.",
          en: "Stores with Stripe, order management, admin panel and premium checkout. No Shopify — custom code, custom rules, custom brand.",
        },
        features: {
          pl: ["Checkout & płatności", "Panel zamówień", "Bez Shopify — własny kod"],
          en: ["Checkout & payments", "Order panel", "No Shopify — custom code"],
        },
      },
    ],
  },

  /* ── Process ─────────────────────────────────────────────────── */
  process: {
    label:    { pl: "Jak pracujemy",        en: "How we work"               },
    heading1: { pl: "Cztery kroki,",        en: "Four steps,"              },
    ice:      { pl: "od rozmowy do działającego produktu.", en: "from conversation to a working product." },
    subtitle: {
      pl: "Najpierw rozumiemy Twój biznes. Dopiero później projektujemy rozwiązanie. Przejrzysty proces bez niespodzianek.",
      en: "First we understand your business. Only then do we design the solution. A transparent process with no surprises.",
    },
    steps: [
      {
        t:        { pl: "Rozmowa & Odkrycie",  en: "Conversation & Discovery" },
        extended: {
          pl: "Dominika prowadzi pierwszą rozmowę — poznajemy Twoje cele, grupę docelową i to, co projekt powinien komunikować. Zanim pojawi się pierwszy piksel, rozumiemy markę od środka.",
          en: "Dominika leads the first conversation — we learn your goals, target audience and what the project should communicate. Before the first pixel appears, we understand the brand from the inside.",
        },
        details: {
          pl: ["Analiza marki i konkurencji", "Definiowanie celów i KPI", "Moodboard i kierunek wizualny", "Zakres projektu i harmonogram"],
          en: ["Brand and competitor analysis", "Defining goals and KPIs", "Moodboard and visual direction", "Project scope and timeline"],
        },
        duration: { pl: "1–3 dni", en: "1–3 days" },
      },
      {
        t:        { pl: "Design & Prototyp",   en: "Design & Prototype"   },
        extended: {
          pl: "Projektujemy w Figmie — każdy ekran, animację i interakcję zanim padnie pierwsza linijka kodu. Widzisz dokładnie co dostajesz i akceptujesz design zanim zaczynamy budować.",
          en: "We design in Figma — every screen, animation and interaction before a single line of code. You see exactly what you're getting and approve the design before we start building.",
        },
        details: {
          pl: ["Wireframes i architektura informacji", "Design systemu — kolory, typografia, komponenty", "Animacje i interakcje w Figmie", "Twoja akceptacja przed wdrożeniem"],
          en: ["Wireframes and information architecture", "Design system — colors, typography, components", "Animations and interactions in Figma", "Your approval before implementation"],
        },
        duration: { pl: "3–7 dni", en: "3–7 days" },
      },
      {
        t:        { pl: "Budowa & Animacja",   en: "Build & Animation"    },
        extended: {
          pl: "Miłosz implementuje zaakceptowany design z obsesją na punkcie detalu. Motion design, optymalizacja wydajności, testy na wszystkich przeglądarkach i rozdzielczościach.",
          en: "Miłosz implements the approved design with an obsession for detail. Motion design, performance optimisation, testing on all browsers and resolutions.",
        },
        details: {
          pl: ["React, Tailwind, Framer Motion", "Optymalizacja wydajności", "Testy cross-browser i responsive", "CMS lub integracje jeśli wymagane"],
          en: ["React, Tailwind, Framer Motion", "Performance optimisation", "Cross-browser and responsive testing", "CMS or integrations if required"],
        },
        duration: { pl: "7–21 dni", en: "7–21 days" },
      },
      {
        t:        { pl: "Launch & Wsparcie",   en: "Launch & Support"     },
        extended: {
          pl: "Deploy, podpięcie domeny i pierwsze tygodnie po launchu — jesteśmy dostępni. Szkolimy z obsługi i dbamy o to, żeby produkt działał dokładnie tak jak powinien.",
          en: "Deploy, domain setup and the first weeks after launch — we're here. We guide you through the CMS and make sure the product works exactly as it should.",
        },
        details: {
          pl: ["Deploy na Vercel lub Netlify", "Konfiguracja domeny i SSL", "Szkolenie z obsługi CMS", "30 dni wsparcia po launchu"],
          en: ["Deploy to Vercel or Netlify", "Domain and SSL configuration", "CMS training", "30 days post-launch support"],
        },
        duration: { pl: "1–2 dni + 30 dni wsparcia", en: "1–2 days + 30 days support" },
      },
    ],
  },

  /* ── Principles ─────────────────────────────────────────────── */
  principles: {
    label: { pl: "Filozofia marki", en: "Brand philosophy" },
    items: [
      {
        num: "01",
        heading: { pl: "Najpierw biznes",       en: "Business first"        },
        body: {
          pl: "Rozumiemy Twoje cele,\nzanim zaprojektujemy rozwiązanie.\nTechnologia służy biznesowi — nie odwrotnie.",
          en: "We understand your goals\nbefore we design the solution.\nTechnology serves business — not the other way around.",
        },
      },
      {
        num: "02",
        heading: { pl: "Relacje, nie zlecenia", en: "Relationships, not jobs" },
        body: {
          pl: "Ludzie kupują historie i zaufanie.\nBudujemy relacje, które\nprzetrwają pojedynczy projekt.",
          en: "People buy stories and trust.\nWe build relationships that\noutlast a single project.",
        },
      },
      {
        num: "03",
        heading: { pl: "Jedna wizja",           en: "One vision"            },
        body: {
          pl: "Od pierwszej rozmowy po finalny kod.\nBez rozmycia między strategią a wdrożeniem.",
          en: "From the first conversation to the final code.\nNo blur between strategy and delivery.",
        },
      },
      {
        num: "04",
        heading: { pl: "Charakter ponad trendy", en: "Character over trends" },
        body: {
          pl: "Produkty powinny zostawiać wrażenie\nrównie długo jak działają.",
          en: "Products should leave an impression\nas long as they work.",
        },
      },
    ],
  },

  /* ── About ───────────────────────────────────────────────────── */
  about: {
    label:    { pl: "O nas",                                      en: "About us"                           },
    heading1: { pl: "Poznaj osoby stojące za",                    en: "Meet the people behind"             },
    ice:      { pl: "Przestrzeń Apps.",                           en: "Przestrzeń Apps."                   },
    intro1: {
      pl: "Za każdym udanym projektem stoją rozmowy, zaufanie i dobre decyzje.",
      en: "Behind every successful project are conversations, trust and good decisions.",
    },
    intro2: {
      pl: "Dlatego nie budujemy anonimowej agencji. Budujemy relacje.",
      en: "That's why we don't build an anonymous agency. We build relationships.",
    },
    closing: {
      pl: "Razem tworzymy zespół, który łączy technologię z ludzkim podejściem.",
      en: "Together we form a team that combines technology with a human approach.",
    },
    team: [
      {
        id: "dominika",
        name: "Dominika Majerczak",
        role: { pl: "Relacje z klientami", en: "Client partnerships" },
        desc: {
          pl: "Pierwsza osoba, którą poznasz. Rozmawia z klientami, poznaje ich cele i dba o to, aby każdy projekt przebiegał spokojnie, jasno i bez zbędnego stresu.",
          en: "The first person you'll meet. She talks with clients, learns their goals and makes sure every project runs smoothly, clearly and without unnecessary stress.",
        },
      },
      {
        id: "milosz",
        name: "Miłosz Czarnecki",
        role: { pl: "Strategia & wdrożenia", en: "Strategy & delivery" },
        desc: {
          pl: "Odpowiada za strategię, architekturę i rozwój. Przekłada potrzeby klientów na rozwiązania, które realnie wspierają rozwój ich biznesu.",
          en: "He handles strategy, architecture and development. He translates client needs into solutions that genuinely support their business growth.",
        },
      },
    ],
    cta:      { pl: "Porozmawiajmy o Twoim pomyśle", en: "Let's talk about your idea" },
    location: { pl: "Poznań · Polska · Praca zdalna", en: "Poznań · Poland · Remote" },
  },

  /* ── BoldStatement ───────────────────────────────────────────── */
  bold: {
    label: { pl: "Fundament dobrego projektu", en: "Foundation of great design" },
    words: {
      pl: ["Zaufanie", "Charakter", "Precyzja", "Relacje", "Przestrzeń"],
      en: ["Trust",    "Character", "Precision", "Relations", "Space"   ],
    },
  },

  /* ── Testimonials ────────────────────────────────────────────── */
  testimonials: {
    label:    { pl: "Opinie klientów",       en: "Client testimonials"  },
    heading1: { pl: "Najlepszą referencją",  en: "The best reference"   },
    ice:      { pl: "jest efekt.",           en: "is the result."       },
    subtitle: {
      pl: "Każdy projekt oceniamy przez pryzmat efektu — nie tylko technologii i terminów.",
      en: "We measure every project by its outcome — not just technology and timelines.",
    },
    bottom_note: {
      pl: "Opinie od prawdziwych klientów — bez anonimowości, bez fikcji.",
      en: "Reviews from real clients — no anonymity, no fiction.",
    },
    roles: {
      pl: ["Klient",  "Właścicielka", "Organizator"],
      en: ["Client",  "Owner",        "Organizer"  ],
    },
    featured: {
      quote: {
        pl: "Portal wygląda premium i działa szybko. Klienci regularnie pytają nas, kto to robił.",
        en: "The portal looks premium and runs fast. Clients regularly ask us who built it.",
      },
      highlight: {
        pl: "kto to robił.",
        en: "who built it.",
      },
      author: "Małgorzata Aptacy",
      company: "Aptacy Nieruchomości",
    },
    quotes: [
      {
        pl: "Miłosz podszedł do projektu jak do własnego produktu. Zanim padła pierwsza linijka kodu, wiedział więcej o marce Balans niż my sami. Efekt przeszedł oczekiwania — strona buduje dokładnie tę atmosferę, której szukaliśmy.",
        en: "Miłosz approached the project as if it were his own product. Before a single line of code was written, he knew more about the Balans brand than we did. The result exceeded expectations — the site builds exactly the atmosphere we were looking for.",
      },
      {
        pl: "Współpraca wzorowa — jasny harmonogram, zero niespodzianek, gotowość do wyjaśnień na każdym etapie. Portal wygląda premium i działa szybko. Klienci regularnie pytają nas, kto to robił.",
        en: "Exemplary collaboration — a clear schedule, zero surprises, always ready to explain at every stage. The portal looks premium and runs fast. Clients regularly ask us who built it.",
      },
      {
        pl: "Aplikacja działała bez zarzutu — nawet offline w górach. Miłosz rozumiał od razu, że to narzędzie dla konkretnych ludzi w konkretnym miejscu i czasie. Dokładnie to dostaliśmy.",
        en: "The app worked flawlessly — even offline in the mountains. Miłosz understood straight away that this was a tool for specific people in a specific place and time. That's exactly what we got.",
      },
    ],
  },

  /* ── Pricing ─────────────────────────────────────────────────── */
  pricing: {
    label:    { pl: "Zakres współpracy",  en: "Ways of working"   },
    heading1: { pl: "Cztery kierunki.",    en: "Four directions."  },
    ice:      { pl: "Jedna filozofia.",   en: "One philosophy."   },
    subtitle: {
      pl: "Nie sprzedajemy pakietów. Każda współpraca zaczyna się od rozmowy i kończy produktem z charakterem.",
      en: "We don't sell packages. Every collaboration starts with a conversation and ends with a product with character.",
    },
    cta:      { pl: "Porozmawiajmy", en: "Let's talk" },
    cta_full: { pl: "Porozmawiajmy o Twoim pomyśle →", en: "Let's talk about your idea →" },
    bottom_note: {
      pl: "Każdy projekt to osobna rozmowa. Napisz kilka zdań — odpowiemy szczerze, czy i jak możemy pomóc.",
      en: "Every project is its own conversation. Write a few sentences — we'll reply honestly about whether and how we can help.",
    },
    modes: [
      {
        name:     { pl: "Micro Presence",     en: "Micro Presence"     },
        for_whom: {
          pl: "Małe marki i pierwsze kroki w sieci",
          en: "Small brands and first steps online",
        },
        effect: {
          pl: "Prosta strona, która jednak mówi coś o tym, kim jesteś.",
          en: "A simple site that still says something about who you are.",
        },
        desc: {
          pl: "Przemyślana wizytówka cyfrowa — zaprojektowana z intencją, nie sklejona z templatów. Jeden ekran lub kilka, ale każdy z charakterem.",
          en: "A considered digital calling card — designed with intention, not assembled from templates. One screen or a few, but each with character.",
        },
        range: { pl: "od 1 500 zł", en: "from €400" },
      },
      {
        name:     { pl: "Digital Presence",   en: "Digital Presence"   },
        for_whom: {
          pl: "Marki osobiste, butikowe firmy i projekty premium",
          en: "Personal brands, boutique firms and premium projects",
        },
        effect: {
          pl: "Pierwsze wrażenie, które zostaje dłużej niż scroll.",
          en: "A first impression that lasts longer than a scroll.",
        },
        desc: {
          pl: "Strony budujące atmosferę, zaufanie i wyraźny charakter marki — projektowane z naciskiem na rytm, typografię i doświadczenie użytkownika.",
          en: "Websites that build atmosphere, trust and a distinct brand character — designed with emphasis on rhythm, typography and user experience.",
        },
        range: { pl: "od 6 000 zł", en: "from €1 500" },
      },
      {
        name:     { pl: "Product Experience", en: "Product Experience" },
        for_whom: {
          pl: "Startupy, aplikacje i produkty SaaS",
          en: "Startups, applications and SaaS products",
        },
        effect: {
          pl: "Produkty, które wydają się intuicyjne zanim użytkownik zdąży się nauczyć.",
          en: "Products that feel intuitive before the user has even learned to use them.",
        },
        desc: {
          pl: "Interfejsy i systemy projektowane wokół klarowności, motion hierarchy i świadomego UX — od MVP po pełny produkt.",
          en: "Interfaces and systems designed around clarity, motion hierarchy and intentional UX — from MVP to full product.",
        },
        range: { pl: "od 12 000 zł", en: "from €3 000" },
      },
      {
        name:     { pl: "Custom Systems",     en: "Custom Systems"     },
        for_whom: {
          pl: "Niestandardowe platformy, narzędzia i większe doświadczenia cyfrowe",
          en: "Custom platforms, tools and larger digital experiences",
        },
        effect: {
          pl: "Cyfrowe produkty budowane od fundamentów — bez kompromisów i gotowych schematów.",
          en: "Digital products built from the ground up — no compromises, no predefined schemas.",
        },
        desc: {
          pl: "Złożone produkty wymagające indywidualnej architektury i pełnej spójności systemu — projektowane i budowane w całości.",
          en: "Complex products requiring bespoke architecture and full system coherence — conceived and built end-to-end.",
        },
        range: { pl: "wycena indywidualna", en: "individual quote" },
      },
    ],
  },

  /* ── FAQ ─────────────────────────────────────────────────────── */
  faq: {
    label:    { pl: "FAQ",                          en: "FAQ"                             },
    heading1: { pl: "Pytania, które",               en: "Questions worth"                 },
    ice:      { pl: "warto zadać wcześniej.",        en: "asking early."                   },
    subtitle: {
      pl: "Nie znalazłeś odpowiedzi? Napisz — odpowiemy w ciągu 24 godzin.",
      en: "Didn't find an answer? Write — we'll reply within 24 hours.",
    },
    cta_question: { pl: "Masz inne pytanie?",  en: "Have another question?" },
    cta_link:     { pl: "Napisz do nas",        en: "Write to us"            },
    items: [
      {
        q: { pl: "Ile trwa realizacja projektu?",                 en: "How long does a project take?"              },
        a: {
          pl: "Strona firmowa lub landing page: zazwyczaj 2–3 tygodnie. Aplikacja webowa lub SaaS: 4–8 tygodni. Wszystko zależy od zakresu — po briefie zawsze podajemy konkretne daty i trzymamy się harmonogramu.",
          en: "A company website or landing page: usually 2–3 weeks. A web application or SaaS: 4–8 weeks. It all depends on scope — after the brief we always give specific dates and stick to the schedule.",
        },
      },
      {
        q: { pl: "Jak wygląda model płatności?",                  en: "What does the payment model look like?"     },
        a: {
          pl: "50% zaliczki przed startem projektu, 50% po oddaniu gotowego produktu. Przy większych zleceniach możliwy jest harmonogram płatności etapowych — ustalamy to indywidualnie na etapie briefu.",
          en: "50% upfront before the project starts, 50% on delivery. For larger projects, a staged payment schedule is possible — we agree on this individually during the brief.",
        },
      },
      {
        q: { pl: "Czy zobaczę design zanim zaczniecie kodować?",  en: "Will I see the design before you start coding?" },
        a: {
          pl: "Tak — zawsze projektujemy w Figmie i przed pierwszą linijką kodu czekamy na Twoją akceptację. Widzisz każdy ekran, animację i interakcję. Bez niespodzianek na etapie wdrożenia.",
          en: "Yes — we always design in Figma and wait for your approval before the first line of code. You see every screen, animation and interaction. No surprises at the implementation stage.",
        },
      },
      {
        q: { pl: "Ile rund poprawek jest wliczonych w cenę?",     en: "How many revision rounds are included?"     },
        a: {
          pl: "2 rundy poprawek do projektu graficznego w standardzie każdego zlecenia. Dalsze iteracje są możliwe i wyceniane indywidualnie — zazwyczaj nie są potrzebne przy dobrym briefie.",
          en: "2 rounds of design revisions are included as standard with every project. Further iterations are possible and priced individually — they're usually not needed with a good brief.",
        },
      },
      {
        q: { pl: "Czy oferujecie wsparcie po launchcie?",         en: "Do you offer post-launch support?"          },
        a: {
          pl: "Tak — 30 dni wsparcia technicznego po launch jest wliczone w cenę. Dla stałych klientów oferujemy miesięczny retainer: aktualizacje, optymalizacja i szybkie reakcje na błędy.",
          en: "Yes — 30 days of technical support after launch is included in the price. For regular clients we offer a monthly retainer: updates, optimisation and fast bug responses.",
        },
      },
      {
        q: { pl: "Czy pracujecie wyłącznie z klientami z Poznania?", en: "Do you work only with clients from Poznań?" },
        a: {
          pl: "Nie — pracujemy w pełni zdalnie z klientami z całej Polski i Europy. Całą współpracę prowadzimy przez Meet/Zoom i Figmę. Lokalizacja nie ma znaczenia, efekt owszem.",
          en: "No — we work fully remotely with clients across Poland and Europe. All collaboration happens via Meet/Zoom and Figma. Location doesn't matter, the result does.",
        },
      },
    ],
  },

  /* ── Contact ─────────────────────────────────────────────────── */
  contact: {
    label:    { pl: "Kontakt",      en: "Contact"       },
    heading1: { pl: "Masz pomysł?", en: "Have an idea?" },
    ice:      { pl: "Porozmawiajmy.", en: "Let's talk."   },
    subtitle: {
      pl: "Napisz parę zdań o swoim projekcie — odpowiemy w ciągu 24 godzin z wstępną wyceną i propozycją kroków.",
      en: "Write a few lines about your project — we'll reply within 24 hours with an honest assessment and next steps.",
    },
    email_label: { pl: "E-mail", en: "E-mail" },
    phone_label: { pl: "Telefon", en: "Phone" },
    response:    { pl: "Odpowiadamy w 24h", en: "We respond within 24h" },
    bullets: {
      pl: ["Odpowiadamy w ciągu 24h", "Bezpłatna wycena projektu", "Konsultacja online — Meet / Zoom", "Baza: Poznań · praca zdalna"],
      en: ["We reply within 24h", "Free project quote", "Online consultation — Meet / Zoom", "Based in Poznań · working remotely"],
    },
    form: {
      name_label:    { pl: "Imię i nazwisko *",      en: "Full name *"             },
      name_ph:       { pl: "Anna Kowalska",          en: "John Smith"              },
      email_label:   { pl: "E-mail *",               en: "E-mail *"                },
      email_ph:      { pl: "anna@firma.pl",          en: "john@company.com"        },
      type_label:    { pl: "Rodzaj projektu",        en: "Project type"            },
      type_ph:       { pl: "Wybierz rodzaj",         en: "Choose type"             },
      budget_label:  { pl: "Budżet orientacyjny",    en: "Approximate budget"      },
      budget_ph:     { pl: "Wybierz przedział",      en: "Choose range"            },
      message_label: { pl: "Opisz projekt *",        en: "Describe your project *" },
      message_ph:    { pl: "Powiedz parę słów o tym, co chcesz zbudować…", en: "Tell us a few words about what you want to build…" },
      submit:        { pl: "Wyślij zapytanie →",     en: "Send inquiry →"          },
      submitting:    { pl: "Wysyłam…",               en: "Sending…"                },
      privacy:       { pl: "Twoje dane służą tylko do odpowiedzi. Nie spamujemy.", en: "Your data is used only to reply. No spam." },
      privacy_link:  { pl: "Polityka prywatności", en: "Privacy Policy" },
    },
    project_types: {
      pl: ["Strona firmowa / landing page", "Aplikacja webowa", "SaaS / Produkt", "Sklep internetowy", "Redesign istniejącej strony", "Inny"],
      en: ["Company website / landing page", "Web application", "SaaS / Product", "Online store", "Redesign of existing site", "Other"],
    },
    budgets: {
      pl: ["do 2 000 zł", "2 000 – 6 000 zł", "6 000 – 18 000 zł", "18 000+ zł", "Do ustalenia"],
      en: ["up to €500", "€500 – €1 500", "€1 500 – €5 000", "€5 000+", "TBD / Flexible"],
    },
    success_title: { pl: "Dziękujemy!",                  en: "Thank you!"                  },
    success_sub:   { pl: "Odpowiemy w ciągu 24 godzin.", en: "We'll reply within 24 hours." },
    toast_ok:      { pl: "Dziękujemy! Odpowiemy w ciągu 24 godzin.", en: "Thank you! We'll reply within 24 hours." },
    toast_err:     { pl: "Coś poszło nie tak. Napisz bezpośrednio na przestrzenapps@gmail.com", en: "Something went wrong. Write directly to przestrzenapps@gmail.com" },
    errors: {
      name:      { pl: "Imię i nazwisko jest wymagane",    en: "Full name is required"        },
      email_req: { pl: "Adres e-mail jest wymagany",       en: "E-mail address is required"   },
      email_inv: { pl: "Podaj prawidłowy adres e-mail",    en: "Enter a valid e-mail address" },
      message:   { pl: "Opisz swój projekt",               en: "Describe your project"        },
    },
  },

  /* ── Footer ──────────────────────────────────────────────────── */
  footer: {
    tagline: {
      pl: "Pomagamy firmom rozwijać się dzięki dobrze zaprojektowanym rozwiązaniom cyfrowym — bez szablonów, z ludzkim podejściem.",
      en: "We help businesses grow through well-designed digital solutions — no templates, with a human touch.",
    },
    location:   { pl: "Poznań · Polska · Remote",  en: "Poznań · Poland · Remote"  },
    nav_header: { pl: "Nawigacja",                  en: "Navigation"                },
    con_header: { pl: "Kontakt",                    en: "Contact"                   },
    response:   { pl: "Odpowiadamy w 24h",         en: "We respond within 24h"      },
  },
};